module.exports = __webpack_public_path__ + "static/media/gallery-1.87865f36.jpg";